import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import LatestArticles from './components/LatestArticles';
import TrendingSection from './components/TrendingSection';
import CTASection from './components/CTASection';

export default function Home() {
  useEffect(() => {
    document.title = '吃瓜网站线路一 | 51吃瓜网站入口 | 最新吃瓜黑料爆料 | 网红塌房每日大赛追踪';
  }, []);

  return (
    <>
      {/* JSON-LD Structured Data */}
      <script type="application/ld+json">
        {JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'WebPage',
          'name': '吃瓜网站线路一 - 首页',
          'description': '聚合呈现51吃瓜网站入口、在线观看、最新黑料爆料，追踪网红塌房与每日大赛热点',
          'url': 'http://91blw.cn/',
          'isPartOf': {
            '@type': 'WebSite',
            'name': '吃瓜网站线路一',
            'url': 'http://91blw.cn/',
          },
          'breadcrumb': {
            '@type': 'BreadcrumbList',
            'itemListElement': [{
              '@type': 'ListItem',
              'position': 1,
              'name': '首页',
              'item': 'http://91blw.cn/',
            }],
          },
        })}
      </script>

      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <HeroSection />
          <CategoryGrid />
          <LatestArticles />
          <TrendingSection />
          <CTASection />
        </main>
        <Footer />
      </div>
    </>
  );
}